import React from "react";

export const STATUS_COLORS = {
    default: '#2ca8ff',
    1: '#2ca8ff',
    2: '#2ca8ff',
    3: '#2ca8ff',
    4: '#2ca8ff',
    5: '#2ca8ff',
    6: '#000a2e',
    7: '#0060a8'
};

export const NAME_PROJECT_XLSX = {
    1: 'poseidon',
    2: 'roldan',
    3: 'sales',
    4: 'rrmagicvision',
    5: 'magicdome',
    6: 'euro',
    7: 'obl'
}

export const BUTTON_CONFIGS = {
    default: {
        color: 'primary',
        className: ''
    },
    1: {
        newTicket: { color: 'primary' },
        modal: {
            btnPrimary: { color: 'primary' },
            btnSecondary: { color: 'primary' }
        },
        detail: {
            btnPrimary: { color: 'primary' },
            btnSecondary: { color: 'primary' }
        }
    },
    2: {
        newTicket: { color: 'primary', block: true, icon: "fas fa-plus-circle mr-2" },
        modal: {
            btnPrimary: { color: 'primary' },
            btnSecondary: { color: 'danger' }
        },
        detail: {
            btnPrimary: { color: 'primary' },
            btnSecondary: { color: 'danger' }
        }
    },
    3: {
        newTicket: { color: 'warning' },
        modal: {
            btnPrimary: { color: 'primary' },
            btnSecondary: { color: 'danger' }
        },
        detail: {
            btnSecondary: { color: 'danger' },
            uploadDoc: { color: 'primary' }
        }
    },
    4: {
        newTicket: { color: 'success' },
        modal: {
            btnPrimary: { color: 'success' },
            btnSecondary: { color: 'warning' }
        },
        detail: {
            btnSecondary: { color: 'danger' },
            uploadDoc: { color: 'primary' }
        }
    },
    5: {
        newTicket: { color: 'success' },
        modal: {
            btnPrimary: { color: 'primary' },
            btnSecondary: { color: 'danger' }
        },
        detail: {
            btnSecondary: { color: 'danger' },
            uploadDoc: { color: 'primary' }
        }
    },
    6: {
        newTicket: {
            color: 'primary',
            wrapperClass: 'float-right',
            buttonClass: 'd-flex align-items-center',
            icon: 'icon-plus icon-button-add',
            block: false
        },
        modal: {
            btnPrimary: { color: 'primary', className: 'custom-width-btn', size: "sm" },
            btnSecondary: { color: 'secondary', className: 'custom-width-btn', size: "sm" }
        },
        detail: {
            btnPrimary: { color: 'primary', className: 'custom-width-btn', size: "sm" },
            btnSecondary: { color: 'secondary', className: 'custom-width-btn', size: "sm" }
        }
    },
    7: {
        newTicket: {
            customRender: ({ etiquetas, onclick }) => (
                <div className='float-right'>
                    <div style={{ alignItems: "center", display: "inline-flex" }}>
                        <i className='fas fa-plus-circle fa-2x buton-add mr-1' onClick={onclick} />
                        <span style={{ fontWeight: "bold" }} className='tag-custom-value'>
                            {etiquetas.title}
                        </span>
                    </div>
                </div>
            )
        },
        modal: {
            btnPrimary: { color: 'primary', className: 'btn-rounded-lg', outline: true },
            btnSecondary: { color: 'danger', className: 'text-bold' }
        },
        detail: {
            btnSecondary: { color: 'danger' },
            uploadDoc: { color: 'primary' }
        }
    },

};